import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer'; 
const Motto = () => {
    useEffect(() => {
        document.title = 'Motto -  Sacred Heart School, Ballia - U.P.';  
    }, []); 
   return (
        <>
        <Header/>
            <section className="page-header"> 
                    <div className="page-header__inner">
                    <h2>Motto </h2>
                        <ul className="thm-breadcrumb list-unstyled ml-0">
                            <li><Link to="/"> Home</Link></li>
                            <li>|</li>
                            <li>About</li>
                            <li>|</li>
                            <li> Motto </li>
                        </ul> 
                </div>
            </section>
            <section className="innerbody">
               <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                    <h1 class="head1"> Our Motto : Spiritual Cultural Academic Sporting</h1>
                    <p>The school aims to provide an all round spiritual cultural academic and sporting background to make its students intelligent and useful citizens. <b>Sacred Heart School</b> will thrive to slip in the basic skills necessary to ride on the challenging roller coaster called LIFE. All the staff and students of the school are expected to keep the school motto always uppermost in their minds and ensure standard of excellence in all their day to day activities to ensure success and happiness in their day to day life.</p>
                    </div> 
                </div>
               </div>
             </section>
            <Footer/>
        </>
    )
}

export default Motto